import * as React from "react";
import { MenuPane, MenuPaneHeader } from "../components/menu";
import { i18n } from "../i18n/i18n";
import { useAuthState } from "../state/authState";
import { Todo } from "../components/placeholder";

export function Schedule() {
  return <Todo title={i18n("Schedule")} />;
}
